export const ELEMENT_SIZES = {
  headerHeight: { lg: 130, sm: 80 }
}